export const documentTypes = {
  CNPJ: '9',
  CPF: '10'
}
// { value: 'CTPS', description: 'CTPS', mask: null },
// { value: 'CNH', description: 'CNH', mask: null },
// { value: 'PASS', description: 'PASSAPORTE', mask: null },
// { value: 'TITU', description: 'TÍTULO DE ELEITOR', mask: null },

export default documentTypes
